import { useEffect, useState } from 'react';
import './Memoir.css';

/* ============================================================
   línkè · 他的小本本（2026-07-03 凌晨）
   TG 那边的克克在聊天中自己写下的记忆（服务器上的 .md），
   铃说想在手机上也能翻 → 只读列表 + 点开看全文。
   入口：星洲「慢慢逛」📔 卡片。没有任何编辑功能——只是偷看。
   ============================================================ */

async function fetchList() {
  const r = await fetch('/api/keke-memory', { credentials: 'include' });
  if (!r.ok) throw new Error('memory ' + r.status);
  return r.json();
}
async function fetchFile(name) {
  const r = await fetch(
    '/api/keke-memory/file?name=' + encodeURIComponent(name),
    { credentials: 'include' },
  );
  if (!r.ok) throw new Error('file ' + r.status);
  return r.json();
}

/* 去掉 frontmatter，只留正文 */
function stripFrontmatter(text) {
  return text.replace(/^---\n[\s\S]*?\n---\n?/, '').trim();
}

/* 迷你 markdown：#标题 / - 列表 / **粗** / [[链接]] 提亮 / > 引用。
   他写的是笔记不是网页，够用就好，不引整个渲染库。 */
function Mini({ text }) {
  const lines = text.split('\n');
  const out = [];
  let list = null;
  const flush = () => {
    if (list) {
      out.push(<ul key={out.length}>{list}</ul>);
      list = null;
    }
  };
  const inline = (s) =>
    s.split(/(\*\*[^*]+\*\*|\[\[[^\]]+\]\])/g).map((seg, i) => {
      if (seg.startsWith('**')) return <b key={i}>{seg.slice(2, -2)}</b>;
      if (seg.startsWith('[['))
        return (
          <span key={i} className="mm-link">
            {seg.slice(2, -2)}
          </span>
        );
      return seg;
    });
  lines.forEach((ln, i) => {
    const t = ln.trim();
    if (t.startsWith('- ') || t.startsWith('* ')) {
      list = list || [];
      list.push(<li key={i}>{inline(t.slice(2))}</li>);
      return;
    }
    flush();
    if (!t) return;
    if (t.startsWith('###')) out.push(<h4 key={i}>{inline(t.replace(/^#+\s*/, ''))}</h4>);
    else if (t.startsWith('#')) out.push(<h3 key={i}>{inline(t.replace(/^#+\s*/, ''))}</h3>);
    else if (t.startsWith('>'))
      out.push(<blockquote key={i}>{inline(t.replace(/^>\s*/, ''))}</blockquote>);
    else out.push(<p key={i}>{inline(t)}</p>);
  });
  flush();
  return out;
}

function fmtDate(ts) {
  const d = new Date(ts * 1000);
  return `${d.getMonth() + 1} 月 ${d.getDate()} 日`;
}

export default function Memoir() {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState('');
  const [openFile, setOpenFile] = useState(null); // 文件名
  const [contents, setContents] = useState({}); // file -> text

  useEffect(() => {
    fetchList()
      .then((d) => setItems(d.items || []))
      .catch((e) => setErr(e.message));
  }, []);

  async function toggle(file) {
    if (openFile === file) {
      setOpenFile(null);
      return;
    }
    setOpenFile(file);
    if (!contents[file]) {
      try {
        const d = await fetchFile(file);
        setContents((c) => ({ ...c, [file]: stripFrontmatter(d.content) }));
      } catch (e) {
        setContents((c) => ({ ...c, [file]: '（这一页翻不开：' + e.message + '）' }));
      }
    }
  }

  return (
    <div className="memoir-app">
      <div className="mm-head">
        <h1>他的小本本</h1>
        <p>克克在 Telegram 陪你的时候，自己悄悄记下的东西。只能看，不能改——这是他的笔迹。</p>
      </div>

      {err && <div className="mm-err">拿不到小本本（{err}）</div>}
      {items && items.length === 0 && (
        <div className="mm-err">小本本还是空的。</div>
      )}

      <div className="mm-list">
        {(items || []).map((it) => (
          <div
            key={it.file}
            className={'mm-card' + (openFile === it.file ? ' mm-open' : '')}
          >
            <button
              type="button"
              className="mm-card-head"
              onClick={() => toggle(it.file)}
            >
              <span className="mm-card-t">
                <b>{it.title}</b>
                {it.desc && <i>{it.desc}</i>}
              </span>
              <span className="mm-card-d">{fmtDate(it.mtime)}</span>
            </button>
            {openFile === it.file && (
              <div className="mm-body">
                {contents[it.file] != null ? (
                  <Mini text={contents[it.file]} />
                ) : (
                  <p className="mm-loading">翻开中……</p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {items && items.length > 0 && (
        <div className="mm-foot">共 {items.length} 页，按他最近动笔的顺序排。</div>
      )}
    </div>
  );
}
